import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReviewsList } from '../../components/ReviewsList';
import { Spinner } from '../../components/Spinner';
import { getReviewIds } from '../../selectors/reviews';
import { EmptyListContainer } from '../EmptyListContainer';
import { ReviewsItemContainer } from '../ReviewsItem';
import { useDeferredRender } from './hooks/useDeferredRender';

interface IReviewsListContainerProps {
  isRevisited: boolean;
}

export function ReviewsListContainer({ isRevisited }: IReviewsListContainerProps) {
  const ids = useSelector(getReviewIds);
  const shouldRender = useDeferredRender({ isRevisited });

  if (!shouldRender) {
    return <Spinner height="100svh" />;
  }

  if (ids.length === 0) {
    return <EmptyListContainer />;
  }

  return (
    <ReviewsList>
      {ids.map(reviewId => (
        <ReviewsItemContainer key={reviewId} id={reviewId} />
      ))}
    </ReviewsList>
  );
}
